<template>
    <delivery-form
        :enable-incomplete-registration="true"
        :enable-delivery-waiting-list="true"/>
</template>

<script>
import { SECTION_ACCOUNT } from '@/constants/Registration';
import DeliveryForm from '@/components/forms/register/DeliveryForm';

export default {
    name: 'Delivery',
    components: {
        DeliveryForm,
    },
    mounted() {
        if (!this.$store.getters['register/getSectionCompleted'](SECTION_ACCOUNT)) {
            this.$router.push({ name: 'register.account' });
        }

        this.$scrollTo('#app');
    },
};
</script>
